// extracted by mini-css-extract-plugin
export default {"modalOverlay":"AboutModal_modalOverlay__A+0fc","modalContent":"AboutModal_modalContent__AmG-6","closeButton":"AboutModal_closeButton__shklc"};